import urlPatterns from "./UrlPatterns";
import config from "../config";

export class UrlProvider {
  static getRawUrl(path, base = "/") {
    let url = urlPatterns;

    for (const item of path.split(".")) {
      const newUrl = url?.[item];

      if (typeof newUrl === "undefined") {
        return "";
      }

      url = newUrl;
    }

    if (typeof url !== "string") {
      return "";
    }

    return base + url;
  }

  static getUrl(path, args = {}, base = "/") {
    let url = this.getRawUrl(path, base);

    Object.keys(args).forEach(key => {
      url = url.replace(":" + key, args[key]);
    });

    return url;
  }

  static getLocalizedUrl(locale, path, args = {}, base = "/") {
    let url = this.getRawUrl(`${locale}.${path}`, base);

    if (!url) {
      url = this.getRawUrl(path, base);
    }

    Object.keys(args).forEach(key => {
      url = url.replace(":" + key, args[key]);
    });

    return url;
  }

  static replaceLocaleFromUrl(url, locale) {
    const supportedLocales = config?.supportedLocales || [];

    if (!supportedLocales.includes(locale)) return url;

    const localesRegExp = new RegExp(`/(${supportedLocales.join("|")})/`, "g");
    return url.replace(localesRegExp, `/${locale}/`);
  }

  static getUrlFromPath(path, args = {}) {
    let url = path;

    Object.keys(args).forEach(key => {
      url = url.replace(":" + key, args[key]);
    });

    return url;
  }
}
